import { render, staticRenderFns } from "./SBPaymentForm.vue?vue&type=template&id=6f326466&scoped=true"
import script from "./SBPaymentForm.vue?vue&type=script&lang=js"
export * from "./SBPaymentForm.vue?vue&type=script&lang=js"
import style0 from "./SBPaymentForm.vue?vue&type=style&index=0&id=6f326466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f326466",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
